import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as ButtonBackground } from '../../../assets/images/btn_decision.svg';
import { ReactComponent as ButtonBackgroundWide } from '../../../assets/images/btn_decision_wide.svg';

export interface FancyButtonProps {
  color: string;
  background: string;
  submit?: boolean;
  disabled?: boolean;
  loading?: boolean;
  hidden?: boolean;
  onClick?: () => void;
}

export const FancyButton: React.FC<FancyButtonProps> = ({
  children,
  color,
  background,
  onClick,
  submit,
  disabled,
  loading,
  hidden
}) => {
  return (
    <button
      type={submit ? 'submit' : undefined}
      className={css`
        width: 100%;
        min-height: 56px;
        color: ${disabled ? '#8f8c85' : color};
        /* NOTE: visibility: hidden がないと、aria-hidden: true でボタンを隠しても１度だけフォーカスが当たってしまう。*/
        ${hidden ? 'visibility: hidden;' : ''}
        font-size: 16px;
        overflow: hidden;
        position: relative;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), color 0.2s;
        &:disabled {
          pointer-events: none;
        }
        &:active {
          transform: scale(0.98, 0.95);
        }
        svg {
          color: ${disabled ? '#cdc7bb' : background};
          transition: color 0.2s;
        }
        @media (max-width: 370px) {
          min-height: 50px;
          font-size: 14px;
        }
      `}
      disabled={disabled || loading}
      aria-hidden={hidden}
      onClick={onClick}
    >
      <span
        className={css`
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        `}
      >
        {window.matchMedia('(min-width: 370px)').matches ? (
          <ButtonBackgroundWide />
        ) : (
          <ButtonBackground />
        )}
      </span>
      <span
        className={css`
          position: relative;
        `}
      >
        {children}
      </span>
    </button>
  );
};
